import datepickerLocaleEs from 'date-fns/locale/es';
import datepickerLocaleFr from 'date-fns/locale/fr';
import datepickerLocaleJA from 'date-fns/locale/ja';
import datepickerLocaleKO from 'date-fns/locale/ko';
import datepickerLocalePt from 'date-fns/locale/pt';
import datepickerLocaleTr from 'date-fns/locale/tr';
import datepickerLocaleBn from 'date-fns/locale/bn';
import i18n from 'i18next';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { initReactI18next } from 'react-i18next';

import translationEN from '../../../lang/locales/en/translation.json';
import translationES from '../../../lang/locales/es/translation.json';
import translationPE from '../../../lang/locales/es-PE/translation.json';
import translationFR from '../../../lang/locales/fr/translation.json';
import translationHT from '../../../lang/locales/fr-HT/translation.json';
import translationJA from '../../../lang/locales/ja/translation.json';
import translationKO from '../../../lang/locales/ko/translation.json';
import translationPT from '../../../lang/locales/pt/translation.json';
import translationPTBR from '../../../lang/locales/pt-BR/translation.json';
import translationPTMZ from '../../../lang/locales/pt-MZ/translation.json';
import translationTR from '../../../lang/locales/tr/translation.json';
import translationBN from '../../../lang/locales/bn/translation.json';

// Datepicker translations

registerLocale('es', datepickerLocaleEs);
registerLocale('fr', datepickerLocaleFr);
registerLocale('pt', datepickerLocalePt);
registerLocale('ko', datepickerLocaleKO);
registerLocale('ja', datepickerLocaleJA);
registerLocale('tr', datepickerLocaleTr);
registerLocale('bn', datepickerLocaleBn);

const defaultLang = document.getElementsByTagName('html')[0].getAttribute('lang') ?? process.env.MIX_LOCALE;

const datepickerLocale = defaultLang.includes('-') ? defaultLang.split('-')[0] : defaultLang;
setDefaultLocale(datepickerLocale);

// the translations
const resources = {
    en: {
        translation: translationEN,
    },
    'es-PE': {
        translation: translationPE,
    },
    es: {
        translation: translationES,
    },
    fr: {
        translation: translationFR,
    },
    'fr-HT': {
        translation: translationHT,
    },
    ja: {
        translation: translationJA,
    },
    ko: {
        translation: translationKO,
    },
    pt: {
        translation: translationPT,
    },
    'pt-BR': {
        translation: translationPTBR,
    },
    'pt-MZ': {
        translation: translationPTMZ,
    },
    tr: {
        translation: translationTR,
    },
    bn: {
        translation: translationBN,
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: defaultLang,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
